import React from 'react';
import { 
  Container,
  Grid,
  Paper,
  Typography,
  Button,
  Box
} from '@mui/material';
import {
  DirectionsCar as AutoIcon,
  Home as HomeIcon,
  Business as BusinessIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const UploadTypePage = () => {
  const navigate = useNavigate();

  const insuranceTypes = [
    {
      id: 'auto',
      title: 'Auto Insurance',
      icon: <AutoIcon sx={{ fontSize: 60, color: '#1976d2' }} />,
      description: 'Upload documents for vehicle insurance policies',
      path: '/document-upload'
    },
    {
      id: 'home',
      title: 'Home Insurance',
      icon: <HomeIcon sx={{ fontSize: 60, color: '#1976d2' }} />,
      description: 'Upload documents for residential property insurance',
      path: '/home-upload' // 预留路径
    },
    {
      id: 'commercial',
      title: 'Commercial Insurance',
      icon: <BusinessIcon sx={{ fontSize: 60, color: '#1976d2' }} />,
      description: 'Upload documents for commercial property insurance',
      path: '/commercial-upload' // 预留路径
    }
  ];

  return (
    <Container maxWidth="xl">
      {/* Header Section */}
      <Box sx={{ 
        pt: 4,
        pb: 3,
        textAlign: 'center',
        position: 'relative',
        borderBottom: '1px solid #e0e0e0',
        mb: 4
      }}>
        <Button
          variant="outlined"
          onClick={() => navigate(-1)}
          startIcon={<ArrowBackIcon />}
          sx={{
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#1976d2',
            borderColor: '#1976d2',
            '&:hover': {
              borderColor: '#1565c0',
              backgroundColor: 'rgba(25, 118, 210, 0.04)'
            }
          }}
        >
          Back
        </Button>

        <Typography 
          variant="h4" 
          sx={{ 
            color: '#1976d2',
            fontWeight: 600,
            mb: 1
          }}
        >
          New Insurance Application
        </Typography>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            color: '#666',
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          Select the type of insurance you want to apply for
        </Typography>
      </Box>

      {/* Insurance Type Selection */}
      <Grid container spacing={3} sx={{ px: 2 }}>
        {insuranceTypes.map((type) => (
          <Grid item xs={12} sm={6} md={4} key={type.id}>
            <Paper 
              elevation={3}
              sx={{
                p: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                cursor: 'pointer',
                transition: '0.3s',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: 6,
                  backgroundColor: '#f8f9fa'
                }
              }}
              onClick={() => navigate(type.path)}
            >
              <Box sx={{ mb: 2 }}>
                {type.icon}
              </Box>
              <Typography 
                variant="h5" 
                sx={{ 
                  mb: 2,
                  color: '#1976d2',
                  fontWeight: 500
                }}
              >
                {type.title}
              </Typography>
              <Typography 
                variant="body1" 
                color="text.secondary"
                sx={{ mb: 3 }}
              >
                {type.description}
              </Typography>
              <Button
                variant="outlined"
                sx={{
                  borderColor: '#1976d2',
                  color: '#1976d2',
                  '&:hover': {
                    backgroundColor: '#1976d2',
                    color: '#fff'
                  }
                }}
              >
                Start Application
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default UploadTypePage; 